import { uniqBy } from 'lodash/fp';
import { useState } from 'react';

import ReactSelect from 'dashboard/components/ReactSelect';
import { ModalBody, ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';
import { Role } from 'dashboard/models/role';
import { User } from 'dashboard/models/user';
import Button from 'design-system/components/Button';
import Spacer from 'design-system/components/Spacer';
import { HStack } from 'design-system/components/Stack';

interface AddUserToRoleModalProps {
  role: Role;
  users: User[];
  handleClose: () => void;
  handleSubmit: (userIds: string[]) => void;
  setSearchTerm: (searchTerm: string) => void;
}

const AddUserToRoleModal = ({
  role,
  users,
  handleClose,
  handleSubmit,
  setSearchTerm,
}: AddUserToRoleModalProps) => {
  const [selectedUserIdsAndLabels, setSelectedUserIdsAndLabels] = useState([]);

  const handleSelect = (userIds: string[]) => {
    setSelectedUserIdsAndLabels(
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      userIds.map((id) => {
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        const existingUserIdToLabel = selectedUserIdsAndLabels.find((h) => h.value === id);

        if (existingUserIdToLabel != null) {
          return existingUserIdToLabel;
        } else {
          /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
          return { label: labelForUser(users.find((u) => u.id === id)), value: id };
        }
      }),
    );
  };

  const labelForUser = (user: User) => {
    return `${user.attributes['name-first']} ${user.attributes['name-last']} (${user.attributes['email-address']})`;
  };

  const options = uniqBy(
    (h: { label: string; value: string }) => h.value,
    [
      ...selectedUserIdsAndLabels,
      ...users.map((user) => {
        return {
          label: labelForUser(user),
          value: user.id,
        };
      }),
    ],
  );

  return (
    <ModalContainer data-test='roles-show-add-user-modal'>
      <ModalHeader data-test='roles-show-add-user-modal__header' onClose={handleClose}>
        {`Add a user to ${role.attributes.name}`}
      </ModalHeader>
      <ModalBody>
        <ReactSelect
          /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
          value={selectedUserIdsAndLabels.map((h) => h.value)}
          onChange={handleSelect}
          onInputChange={setSearchTerm}
          isMulti
          options={options}
          placeholder='Search by name and email'
          portal={true}
        />
        <Spacer height={2} />
        <HStack equal={true}>
          <Button
            variant='basic'
            id='roles-show-add-user-modal__close'
            name='roles-show-add-user-modal__close'
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            id='roles-show-add-user-modal__add-button'
            type='submit'
            disabled={selectedUserIdsAndLabels.length === 0}
            onClick={() => {
              /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
              handleSubmit(selectedUserIdsAndLabels.map((h) => h.value));
              handleClose();
            }}
          >
            Add
          </Button>
        </HStack>
      </ModalBody>
    </ModalContainer>
  );
};

export default AddUserToRoleModal;
